
import { hyphenate } from 'vessel/utils'

export default {
  inheritAttrs: false,
  props: {
    model: {
      type: Object,
      default: null
    },
    mutation: {
      type: Object,
      default: null
    },
    client: {
      type: String,
      default: 'site'
    },
    items: {
      type: Array,
      default: null
    },
    parseInput: {
      type: Function,
      default: (val) => val
    },
    parseData: {
      type: Function,
      default: (val) => val
    },
    statusIcon: {
      type: Boolean,
      default: false
    },
    submitOnEnter: {
      type: Boolean,
      default: false
    },
    button: {
      type: Boolean,
      default: true
    },
    buttonText: {
      type: String,
      default: 'forms.submit'
    },
    form: {
      type: Object,
      default: null
    },
    notifyInline: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      disabled: false,
      result: null
    }
  },
  computed: {
    wrapperAttrs() {
      return {
        gap: this.button || this.notifyInline ? 'md' : null,
        ...this.$attrs
      }
    },
    showAlert() {
      return !this.disabled && this.notifyInline && this.result
    }
  },
  methods: {
    notify(data) {
      this.$notify.closeAll()

      const h = this.$createElement
      const messages = data.messages.map(message => {
        return h('p', message)
      })

      const options = {
        type: data.status,
        title: data.notice
      }

      if (this.notifyInline) {
        this.result = {
          ...options,
          text: data.messages.join('. ')
        }
      } else {
        this.$notify({
          ...options,
          message: h('div', messages || []),
          duration: (data.duration || 10) * 1000
        })
      }
    },
    onKeyupEnter(event) {
      if (this.submitOnEnter) {
        this.onSubmit(event)
      }
    },
    onSubmit() {
      if (!this.disabled) {
        this.$emit('submit')

        const form = this.$refs.form

        form.validate((valid) => {
          if (valid) {
            this.disabled = true
            this.$emit('form-valid')
            this.mutate()
          } else {
            this.disabled = false
            this.$emit('form-invalid')
          }
        })
      }
    },
    mutate() {
      if (!this.mutation) return

      const form  = this.$refs.form
      const data  = this.parseData(form.value)
      const input = this.parseInput({ data })

      this.$graphql.mutate({
        mutation: this.mutation,
        clientId: this.client,
        variables: { input }
      })
      .then(({ fullData }) => {
        this.disabled = false

        const resKey = Object.keys(fullData)[0]
        const result = fullData[resKey] || {}

        this.$emit(hyphenate(result.status), { result, input: data })
        this.notify(result)
      })
      .catch(() => {
        this.disabled = false
        this.$emit('error')

        this.notify({
          status: 'error',
          notice: this.$t('errors.generalError'),
          messages: [this.$t('errors.generalErrorText')]
        })
      })
    }
  }
}
